module.exports = __webpack_public_path__ + "static/media/interviewer.923999af.svg";